import type { TRecordingSessionType } from 'app/types/enums/recordingSessionTypes';

export type TJobsReportListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
  statuses: string[];
  from: string;
  to: string;
  asOne: boolean;
  post: boolean;
  meetingTypes?: TRecordingSessionType[];
  durationFrom?: number;
  durationTo?: number;
  includeExternallyManaged: boolean;
};

export const adminJobsKeys = {
  all: [{ module: 'adminJobs' }] as const,
  reportLists: () => [{ ...adminJobsKeys.all[0], scope: 'reportList' }] as const,
  reportList: (params: TJobsReportListParams) => [{ ...adminJobsKeys.reportLists()[0], params }] as const,
  details: () => [{ ...adminJobsKeys.all[0], scope: 'detail' }] as const,
  detail: (jobId: string) => [{ ...adminJobsKeys.details()[0], jobId }] as const,
  enhancements: () => [{ ...adminJobsKeys.all[0], scope: 'enhancements' }] as const,
  enhancementsByJob: (jobId: string) => [{ ...adminJobsKeys.enhancements()[0], jobId }] as const,
  licenseUsages: () => [{ ...adminJobsKeys.all[0], scope: 'licenseUsage' }] as const,
  licenseUsageByJob: (jobId: string) => [{ ...adminJobsKeys.licenseUsages()[0], jobId }] as const,
  pipelineStatuses: () => [{ ...adminJobsKeys.all[0], scope: 'pipelineStatus' }] as const,
  pipelineStatusByJob: (jobId: string) => [{ ...adminJobsKeys.pipelineStatuses()[0], jobId }] as const,
  attempts: () => [{ ...adminJobsKeys.all[0], scope: 'attempts' }] as const,
  attemptsByJob: (jobId: string) => [{ ...adminJobsKeys.attempts()[0], jobId }] as const,
  attemptDetails: () => [{ ...adminJobsKeys.all[0], scope: 'attemptDetail' }] as const,
  attemptDetail: (attemptId: string) => [{ ...adminJobsKeys.attemptDetails()[0], attemptId }] as const,
  attemptLogs: () => [{ ...adminJobsKeys.all[0], scope: 'attemptLogs' }] as const,
  attemptLogsByAttempt: (attemptId: string) => [{ ...adminJobsKeys.attemptLogs()[0], attemptId }] as const,
  signedMediaUrls: () => [{ ...adminJobsKeys.all[0], scope: 'signedMediaUrl' }] as const,
  signedMediaUrl: (jobId: string, file: string) => [{ ...adminJobsKeys.signedMediaUrls()[0], jobId, file }] as const,
  utterances: () => [{ ...adminJobsKeys.all[0], scope: 'utterances' }] as const,
  utterancesByJob: (jobId: string, transcript: string) =>
    [{ ...adminJobsKeys.utterances()[0], jobId, transcript }] as const,
  attachments: () => [{ ...adminJobsKeys.all[0], scope: 'attachment' }] as const,
  attachment: (jobId: string, attachmentId: string) =>
    [{ ...adminJobsKeys.attachments()[0], jobId, attachmentId }] as const,
};
